import NFP from './NotFoundPage';

// eslint-disable-next-line import/prefer-default-export
export var NotFoundPage = NFP;